import { IOnInit } from "angular";
import { GridConfiguration } from "../../../../../../../records/views/recordGridView";
import { IQuery } from "../../../../../../../records/server/query";
import { Record } from "../../../../../../../records/server/crud";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../../../../records/grids/settings/gridSettingsService";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../../../../shared/machineConfigurationCellClassService";

export class MachineTypeIdInfoMachineComponentController implements IOnInit {
  public readonly gridConfiguration!: GridConfiguration;
  public readonly typeId!: Record;
  public readonly defaultQuery: IQuery = {
    CurrentConfiguration: true,
  };
  public currentConfigurationsOnly: boolean = true;

  static $inject = [
    GridSettingsServiceName,
    MachineConfigurationCellClassServiceName,
  ];
  constructor(
    private readonly gridSettingsService: GridSettingsService,
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService
  ) {}

  $onInit() {
    this.defaultQuery.MachineTypeIdId = this.typeId.Id;
    this.gridConfiguration.gridSettings =
      this.gridSettingsService.getGridSettings(
        Symbol("machineTypeIdInfoMachines")
      );
    this.machineConfigurationCellClassService.styleColumns(
      this.gridConfiguration.columns,
      false
    );
  }

  currentConfigurationsOnlyChanged(currentConfigurationsOnly: boolean) {
    this.defaultQuery.CurrentConfiguration = currentConfigurationsOnly
      ? true
      : undefined;

    this.machineConfigurationCellClassService.styleColumns(
      this.gridConfiguration.columns,
      !currentConfigurationsOnly
    );
  }
}
